import { FunctionComponent } from 'react'

const TrialHasEnded: FunctionComponent = () => {
    return (
        <div className="app__inner app__inner--center">
            <article className="text-center">
                <div className="large-heading">Provperioden har tyvärr gått ut</div>
                <p className="preamble">
                    Er provperiod har tyvärr gått ut. För att fortsätta använda Mitt Boende behöver ni skaffa en prenumeration.
                </p>
                <a href="https://www.riksbyggen.se/fastighetsforvaltning/mitt-boende/" className="btn btn-primary">Skaffa Mitt Boende</a>
            </article>
        </div>
    )
}

export default TrialHasEnded